/* @flow */
import React from 'react';

import BirthdateSelector from 'chat/components/BirthdateSelector.jsx';
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import Dialog from 'components/Dialog.jsx';
import UserActions from 'user/UserActions';

type State = {
  birthdate: ?Date,
};

class BirthdayInterruptModal extends React.Component {
  static propTypes = {
    onRequestHide: React.PropTypes.func,
    birthdate: React.PropTypes.instanceOf(Date),
  };

  state: State = {
    birthdate: this.props.birthdate || null,
  };

  onChange = (birthdate: Date) => {
    this.setState({ birthdate });
  }

  onSave = () => {
    const { birthdate } = this.state;
    if (!birthdate) {
      console.error('skipping attempt to save falsy birthdate');
      return;
    }
    UserActions.setBirthdate(birthdate).then(() => {
      if (this.props.onRequestHide) {
        this.props.onRequestHide();
      }
    });
  }

  render() {
    return (
      <Dialog
        eventScreenName="BirthdayInterruptModal"
        allowOverflow
        className="BirthdayInterruptModal"
        title="When is your birthday?"
        size="small"
        onRequestHide={this.props.onRequestHide}>
        <BoxBody>
          <BirthdateSelector onChange={this.onChange} />
          <Button
            disabled={this.state.birthdate === null}
            onClick={this.onSave}>
            Save
          </Button>
        </BoxBody>
      </Dialog>
    );
  }
}

export default BirthdayInterruptModal;



// WEBPACK FOOTER //
// ./src/setup/components/BirthdayInterruptModal.jsx